import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import DevicesOrders from './orders';
import DevicesStock from './stock';
import RequestsInstallationDevice from './RequestsInstallation';

export const devicesRoutes = [
  {'component': <DevicesOrders />, 'path': paths.DevicesOrders},
  {'component': <RequestsInstallationDevice />, 'path': paths.RequestsInstallationDevice},
  {'component': <DevicesStock />, 'path': paths.DevicesStock},
];
